export function toPascalCase(string: string) {
	return `${string}`
		.toLowerCase()
		.replace(/[-_]+/g, " ")
		.replace(/[^\w\s]/g, "")
		.replace(/\s+(.)(\w*)/g, ($1, $2, $3) => `${$2.toUpperCase() + $3}`)
		.replace(/\w/, (s) => s.toUpperCase());
}

export function toKebabCase(string: string) {
	return `${string}`.toLowerCase().replace(/ /g, "-").replace(/:/g, "_");
}

export function ucFirst(string: string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}
